import styled from 'styled-components';
import { memo } from 'react';
import { Hideable } from '@prisjakt/ui/hideable';
import { layout } from '@prisjakt/ui-base';
import { Speed } from '@prisjakt/ui/definitions';
import OverlayBase from '../../../../components/overlay';

export const Overlay = memo(styled(OverlayBase)`
  && {
    /* Cover the header so e.g. the search bar on the frontpage won't peek through */
    z-index: 101;
  }
`);

export const FakeHeader = memo(styled(Hideable).attrs({
  speed: Speed.Slow,
})`
  background: ${props => props.theme.header.bg};
  height: ${layout.headerHeight.mobile.rem};
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  /* Needs a higher z-index than the overlay */
  z-index: 102;
`);

export const SlideLeftContainer = styled.div`
  /* Needed because ReactSwipe sets e.g. a child div to 2x the view width, for some reason */
  width: 100vw;
  max-height: 100vh;
  overflow: hidden;
`;
